/*global $*/
/*eslint no-undef: "error"*/
export default class ToggleProduct {
    classItem = 'toggle-product--item'
    classBlock = 'toggle-product--block'
    classButton = 'toggle-product--button'

    classButtonActive = 'toggle-product__button-active'
    classButtonCatalog = 'toggle-product-catalog'
    classButtonMap = 'toggle-product-map'

    classItemMap = 'section-products-map'

    constructor () {
        let self = this

        $(`.${self.classButton}`).click(function () {
            let type = $(this).data('type')

            $(this).closest(`.${self.classBlock}`).find(`.${self.classButton}`).removeClass(self.classButtonActive)
            $(this).addClass(self.classButtonActive)

            if (type === 'catalog') {
                $(this).closest(`.${self.classBlock}`).removeClass(self.classButtonMap)
                $(this).closest(`.${self.classBlock}`).addClass(self.classButtonCatalog)
                $(this).closest(`.${self.classItem}`).removeClass(self.classItemMap)
            }

            if (type === 'map') {
                $(this).closest(`.${self.classBlock}`).removeClass(self.classButtonCatalog)
                $(this).closest(`.${self.classBlock}`).addClass(self.classButtonMap)
                $(this).closest(`.${self.classItem}`).addClass(self.classItemMap)
            }
        })
    }
}
